module.exports = __webpack_public_path__ + "static/media/lifts.2535c68c.svg";